export default {"src":"/_next/static/media/Boeing.67353a58.svg","height":48,"width":104,"blurWidth":0,"blurHeight":0};